import { intl } from "LocaleWrapper";
import { Call } from "view/planning/container/ContainerPlanning";

const ContainerPlanningVoyageTask = ({
	call,
	fadeOut,
}: {
	call: Call;
	fadeOut: boolean;
}) => {

	const teu = call.loadedTeuOnVoyageAfterCall ?? 0;
	const totalCapacityTeu = (call.remainingTeuCapacity ?? 0) + (call.loadedTeuOnVoyageAfterCall ?? 0);
	const progressTeuPercentage =  teu > 0 ? teu / totalCapacityTeu * 100 : 0;

	return (
		<div className="voyage-task" style={{ opacity: fadeOut ? 0.3 : 1 }}>
			<div className="progress">
				<div className="fill" style={{ width: `${progressTeuPercentage}%` }} />

				<div className="content">
					<span>{teu.toFixed(0)}</span>
					{` / ${call.remainingTeuCapacity ? totalCapacityTeu : "0"} ${intl.formatMessage({ id: "UNIT_TEU" })}`}
				</div>
			</div>
		</div>
	);
};

export default ContainerPlanningVoyageTask;
